/**
 * Legal-policy vocabulary shared by the API (acceptance recording, policy content routes) and the
 * UIs (registration / invite-claim consent, policy links).
 *
 * POLICY_VERSIONS is the ONLY place a policy version is written (BR-16). Bump a policy's entry here
 * whenever its content changes materially; every recorder and display reads it from here, and the
 * registration schemas reject any other version.
 */
import { z } from 'zod';
/** Every policy type that can be recorded in policy_acceptances.policy_type. */
export const POLICY_TYPES = [
    'platform_terms',
    'privacy_policy',
    'landlord_supplement',
    'tenant_supplement',
    'acceptable_use',
    'bank_data_access',
];
/**
 * Policy types backed by a published markdown document (docs/policies/) and accepted via
 * clickwrap at registration. bank_data_access is accepted in-product, not as a document.
 */
export const DOCUMENT_POLICY_TYPES = [
    'platform_terms',
    'privacy_policy',
    'landlord_supplement',
    'tenant_supplement',
    'acceptable_use',
];
/** Current version of each policy. Bump here when a policy's content changes — nowhere else. */
export const POLICY_VERSIONS = {
    platform_terms: '2026-03-01',
    privacy_policy: '2026-10-15', // cookie-notice re-prompts are versioned separately: COOKIE_NOTICE_VERSION (@resida/api-types/cookie-consent)
    landlord_supplement: '2026-03-01',
    tenant_supplement: '2026-03-01',
    acceptable_use: '2026-03-01',
    bank_data_access: '2026-03-01',
};
/** True when `version` is the current version of `policyType`. */
export function isCurrentPolicyVersion(policyType, version) {
    return POLICY_VERSIONS[policyType] === version;
}
/**
 * A single policy consent submitted with a registration or invite claim. Only the current
 * version of each policy is accepted (BR-16).
 */
export const ConsentPolicySchema = z
    .object({
    policyType: z.enum(DOCUMENT_POLICY_TYPES),
    policyVersion: z.string().min(1).max(20),
})
    .refine((p) => isCurrentPolicyVersion(p.policyType, p.policyVersion), {
    message: 'Policy version is not current',
    path: ['policyVersion'],
});
//# sourceMappingURL=legal-policies.js.map